import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { ProtectedRoute } from '@/routes/common/ProtectedRoute';
import { SuspenseWrapper } from '@/routes/common/SuspenseWrapper';

const ColumnList = lazy(() => import('@/pages/columns/List'));
const ColumnCreate = lazy(() => import('@/pages/columns/Create'));
const ColumnEdit = lazy(() => import('@/pages/columns/Edit'));
const ColumnDetail = lazy(() => import('@/pages/columns/Detail'));

export const columnRoutes: RouteObject = {
  path: 'columns',
  children: [
    {
      index: true,
      element: <Navigate to="list" replace />,
    },
    {
      path: 'list',
      element: (
        <ProtectedRoute pageKey="page:columns:list">
          <SuspenseWrapper>
            <ColumnList />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'create',
      element: (
        <ProtectedRoute pageKey="page:columns:create">
          <SuspenseWrapper>
            <ColumnCreate />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'edit/:id',
      element: (
        <ProtectedRoute pageKey="page:columns:edit">
          <SuspenseWrapper>
            <ColumnEdit />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
    {
      path: 'detail/:id',
      element: (
        <ProtectedRoute pageKey="page:columns:detail">
          <SuspenseWrapper>
            <ColumnDetail />
          </SuspenseWrapper>
        </ProtectedRoute>
      ),
    },
  ],
};

